export function getVolume (dataArray: Float32Array) {
  const magicNumber = 200
  let sumSquares = 0.0
  for (const amplitude of dataArray) { sumSquares += amplitude * amplitude }
  return Math.sqrt(sumSquares / dataArray.length) * magicNumber
}

export const getParticipantShortCallIdFromTrackId = (id: string) => id.split('-').at(0)

export const getParticipantNumberFromTrackId = (id: string) => id.split('-').at(1)

export const getParticipantNumberFromStreamId = (streamId: MediaStream['id']) => streamId.split('-').at(1)

export const getTrackNameFromTrackId = (id: string) => id.split('-').at(2)
